import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import type { DocPage } from '../docsStructure'

interface DocsPageNavigationProps {
  prev: DocPage | null
  next: DocPage | null
}

export function DocsPageNavigation({ prev, next }: DocsPageNavigationProps) {
  if (!prev && !next) {
    return null
  }

  return (
    <div className="flex justify-between items-center mt-12 pt-8 border-t">
      <div className="flex-1">
        {prev && (
          <Link to={`/docs/${prev.slug}`}>
            <Button variant="outline" className="gap-2">
              <ChevronLeft className="h-4 w-4" />
              <div className="text-left">
                <div className="text-xs text-muted-foreground">Previous</div>
                <div>{prev.title}</div>
              </div>
            </Button>
          </Link>
        )}
      </div>

      <div className="flex-1 flex justify-end">
        {next && (
          <Link to={`/docs/${next.slug}`}>
            <Button variant="outline" className="gap-2">
              <div className="text-right">
                <div className="text-xs text-muted-foreground">Next</div>
                <div>{next.title}</div>
              </div>
              <ChevronRight className="h-4 w-4" />
            </Button>
          </Link>
        )}
      </div>
    </div>
  )
}
